import type { TEvent } from './models';
import { hasDataLayer, hasYandexMetric, isNotEmpty } from './helpers';

export const sendEvent = (evt: TEvent = {}): void => {
    const globalContext = window;
    const { ymEvent, ...gaEvent } = evt;

    if (process.env.NODE_ENV === 'development') {
        if (isNotEmpty(gaEvent)) {
            console.info('Google Event:\n', gaEvent);
        }
        if (isNotEmpty(ymEvent)) {
            const ymEvents = [ymEvent].flat();
            ymEvents.forEach(event => {
                const { method = 'reachGoal', params } = event;
                console.info('Yandex Event:\n', method, ...[params].flat());
            });
        }
    }

    if (hasDataLayer(globalContext) && isNotEmpty(gaEvent)) {
        const completeEvt = {
            path: globalContext.location.pathname,
            ...gaEvent,
        };

        globalContext.dataLayer.push(completeEvt);
    }

    if (hasYandexMetric(globalContext) && isNotEmpty(ymEvent)) {
        const ymEvents = [ymEvent].flat();
        ymEvents.forEach(event => {
            const { method = 'reachGoal', params } = event;

            globalContext.ym(`${process.env.CUSTOM_YTM_ID}`, method, ...[params].flat());
        });
    }
};
